import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-moodle-setup-guide',
  templateUrl: './moodle-setup-guide.component.html',
  styleUrl: './moodle-setup-guide.component.scss',
})
export class MoodleSetupGuideComponent {
  constructor(public translate: TranslateService) {}

  get language() {
    return this.translate.currentLang;
  }

  closeTab() {
    window.close();
  }
}
